<template>
  <b-modal id="parent-goal-modal" modal-class="pgm" scrollable @hide="clearSelection">
    <template #modal-title>{{ modalTitle }}</template>
    <div class="pgm-body">
      <p class="text-main">Parent skill</p>
      <b-form-select
        :disabled="hasEditing"
        :value="selected"
        :options="options"
        @change="handleChangeSelect"
      >
        <b-form-select-option :value="null">Please select an option</b-form-select-option>
      </b-form-select>
      <p class="text-main mt-3">
        select the answers to create your plan
      </p>
      <create-goal-form
        v-if="selected"
        :questions="questions"
        :answers="answers"
        :ref="'planningFormModal'"
      />
    </div>
    <template #modal-footer>
      <b-button variant="warning" class="px-5" @click="handleSaveGoal">Save</b-button>
    </template>
  </b-modal>
</template>
<script>
import { sentenceCase } from '@/utils';
import CreateGoalForm from '@/components/planning/CreateGoalForm.vue';
export default {
  components: {
    CreateGoalForm,
  },
  props: {
    defaultSkill: {
      type: Number,
      default: null,
    },
    planningSkills: {
      type: Array,
      default: () => [],
    },
    questions: {
      type: Array,
      default: () => [],
    },
    answers: {
      type: Array,
      default: () => [],
    },
    hasEditing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected: null,
    };
  },
  watch: {
    defaultSkill() {
      this.selected = this.defaultSkill;
    },
  },
  computed: {
    options() {
      return this.translatePlanningSkillsToOptions(this.planningSkills);
    },
    modalTitle() {
      return this.hasEditing ? 'Edit Parent Goal' : 'New Parent Goal';
    },
  },
  methods: {
    translatePlanningSkillsToOptions(skills = []) {
      if (!skills.length) return [];
      return skills?.map((skill) => ({
        value: skill?.id,
        text: sentenceCase(skill.text),
        skill,
      }));
    },
    handleChangeSelect(value) {
      this.selected = value;
      this.$emit('onSkillChange', { skillId: value });
    },
    handleSaveGoal() {
      const formComponent = this.$refs['planningFormModal'];
      const answers = formComponent?.values;
      this.$emit('onCreateGoal', answers);
      this.$bvModal.hide('parent-goal-modal');
      this.clearSelection();
    },
    clearSelection() {
      if (!this.hasEditing) {
        this.selected = null;
      }
    },
  },
};
</script>
<style lang="scss">
.pgm {
  .modal-footer {
    justify-content: center;
  }
}
</style>
